export enum DomainList {
  isec = "thebcrjp.com",
  bbl = "bcrbullion.com",
}

// export const isecDomain = ["jp.thebcr.com", "portal.isec.jp", "thebcrjp.com"];
export const isecDomain = ["thebcrjp.com"];

export const isIsecDomain = () => {
  const hostname = window.location.hostname;
  if (isecDomain.includes(hostname)) {
    return true;
  }
  return false;
};

export const isBblDomain = () => {
  const hostname = window.location.hostname;
  if (hostname.includes(DomainList.bbl)) {
    return true;
  }
  return false;
};
